if(!customElements.get('slider-captions')) {
  class ComponentSliderCaptions extends HTMLElement {
    constructor() {
      super();
      this.sliderElement = this.querySelector('.keen-slider');

      this.carouselMode = this.dataset.carouselMode;
      this.carouselLoop = this.dataset.carouselLoop;
      this.carouselAutoplay = this.dataset.carouselAutoplay;

      setTimeout(()=>{ //The timeout is for the customizer
        this.initSlider();
      }, 1);
    }

    initSlider() {
      var config = {
        mode: this.carouselMode,
        loop: this.carouselLoop=="true",
        prevButton: this.querySelector('.keen-arrow.prev'),
        nextButton: this.querySelector('.keen-arrow.next'),
        autoplay: this.carouselAutoplay, 
        customAnimation: 'fade',  
        setContainerHeight: true,     
        breakpoints: {
          '(min-width: 901px)': {
            centered: false,
            spacing: 0,
            slidesPerView: 1
          },
          '(min-width: 601px) and (max-width: 900px)': {
            centered: false,
            spacing: 0,
            slidesPerView: 1
          },
          '(max-width: 600px)': {
            centered: false,
            spacing: 0,
            slidesPerView: 1
          }
        }
      }
      var dots = this.querySelector('.keen-dots');
      if (dots) {
        config = {...config, dots: dots};
      } else {
        var band = this.querySelector('.keen-nav-bar');
        config = {...config, navBar: band, rubberband: false};
      }
      this.sliderObj = new KeenSlider(this.sliderElement, config);
    }
  }
  customElements.define('slider-captions', ComponentSliderCaptions);
}